export default "__VITE_ASSET__DjyC1Nrz__"